import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "search-container" }
const _hoisted_2 = { class: "dropdown-label" }
const _hoisted_3 = { class: "search-input" }
const _hoisted_4 = ["placeholder"]

import { ref, watch } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'SearchInputComponent',
  props: {
  id: {
    type: String,
  },
  placeholder: {
    type: String,
    default: '',
  },
  initialValue: {
    type: String,
    default: '',
  },
  label: {
    type: String,
    default: 'Label',
  },
  modelValue: {
    type: String
  }
},
  emits: ['search', 'updateValue'],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const props = __props;

const searchTerm = ref<string>((props.modelValue)?props.modelValue:props.initialValue);

const triggerSearch = () => {
    emit('search', searchTerm.value);
}

watch(() => props.modelValue, (newValue) => {
  if (newValue) {
    searchTerm.value = newValue;
  }
});


watch(searchTerm, (newValue) => {
  emit('updateValue', props.id, newValue);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(__props.label), 1),
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchTerm).value = $event)),
        onKeyup: _withKeys(triggerSearch, ["enter"]),
        placeholder: __props.placeholder,
        class: "search-input-field"
      }, null, 40, _hoisted_4), [
        [_vModelText, searchTerm.value]
      ]),
      _createElementVNode("button", {
        onClick: triggerSearch,
        onTouchstart: triggerSearch,
        class: "search-input-button bp-icon-Search"
      }, null, 32)
    ])
  ]))
}
}

})